module.exports = __webpack_public_path__ + "img/mission.b27d0fc3.png";